import {
  CognitiveFilterRequestModel,
  CognitiveSearchResultModel,
  ImageLibrarySearchResult,
  TableauEmbedModel,
  TechLaunchDatabaseModel,
  AnalyticsBuilderAutocompleteOption,
  AnalyticsBuilderAutocompleteTaxonomy,
  AnalyticsBuilderDataRequestModel,
  AnalyticsBuilderDataResponseModel,
} from '@/types';
import { buildAPIUrl, responseInterceptor, toQueryString } from '.';

export const searchImages = async (
  filterRequest: CognitiveFilterRequestModel,
): Promise<CognitiveSearchResultModel<ImageLibrarySearchResult>> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/core/SearchImages`, {
      method: 'POST',
      body: JSON.stringify(filterRequest),
    }),
  );

  return response.json();
};

export const searchTechDatabase = async (
  filterRequest: CognitiveFilterRequestModel,
): Promise<CognitiveSearchResultModel<TechLaunchDatabaseModel>> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/core/SearchTechDatabase`, {
      method: 'POST',
      body: JSON.stringify(filterRequest),
    }),
  );

  return response.json();
};

export const getTableauEmbedUrl = async (request: { workbook: string; view: string }): Promise<TableauEmbedModel> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/core/tableau/getembedurl${toQueryString(request)}`),
  );

  return response.json();
};

export const getAnalyticsBuilderData = async (
  filterRequest: AnalyticsBuilderDataRequestModel,
): Promise<AnalyticsBuilderDataResponseModel> => {
  const urlSegment = filterRequest.urlSegment
    .map((segment) => segment.replace(/^\/+|\/+$/g, ''))
    .filter((segment) => segment.length > 0)
    .join('/');

  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/core/builder/${urlSegment}${toQueryString(filterRequest.queryParams)}`),
  );

  return response.json();
};

export const getAnalyticsBuilderAutocompleteData = async (
  taxonomy: AnalyticsBuilderAutocompleteTaxonomy,
  searchTerm: string,
): Promise<AnalyticsBuilderAutocompleteOption[]> => {
  let queryParams: Record<string, string> = { searchTerm };
  if (taxonomy === AnalyticsBuilderAutocompleteTaxonomy.City) {
    queryParams = { cityName: searchTerm };
  }
  const response = await responseInterceptor(
    await fetch(
      `${await buildAPIUrl()}/services/core/builder/refinements/${taxonomy}/search${toQueryString(queryParams)}`,
    ),
  );

  if (response.ok) {
    const rezults = await response.json();
    if (taxonomy === AnalyticsBuilderAutocompleteTaxonomy.City) {
      return rezults.map((rezult: any) => ({
        value: String(rezult.GEOCODE),
        label: rezult.City,
      }));
    } else {
      return rezults.map((rezult: any) => ({
        value: String(rezult.id),
        label: rezult.name,
      }));
    }
  }

  return [];
};
